/* eslint-disable */
import React, { Component } from 'react'
import classNames from 'classnames'
import './page.scss';

class Page extends Component {
    constructor(props) {
        super(props);
        this.state = {
            curPageIndex: 0,
        }

    }
    prevPageHandler(e) {
        let { curPageIndex } = this.state;
        (curPageIndex > 0) ? this.changePage(curPageIndex - 1) : alert("已经是第一页了哦");
    }
    // 选择页码
    changePageHandler(e, i) {
        this.changePage(i)
    }

    changePage(index) {
        let { setPageIndex } = this.props;
        setPageIndex(index);
        this.setState({
            curPageIndex: index
        })
    }
    // 下一页
    nextPageHandler(e) {
        let { curPageIndex } = this.state;
        let { pageLen } = this.props;
       (curPageIndex < (pageLen - 1)) ? this.changePage(curPageIndex + 1) : alert("已经是最后页了哦");
    }

    render() {
        let { curPageIndex } = this.state;
        let { pageLen, setPageIndex } = this.props;
        let list = [];
        if(pageLen > 1) {
            list.push(<li className="page_item page_prev" key='prev' onClick={(e) => this.prevPageHandler(e)}>{"上一页"}</li>);
            for(let i = 0; i < pageLen; i++) {
                if(curPageIndex == i){
                    list.push(<li className="page_item page_cont on" key={i} onClick={(e) => this.changePageHandler(e, i)}>{ i + 1 }</li>);
                } else {
                    list.push(<li className="page_item page_cont" key={i} onClick={(e) => this.changePageHandler(e, i)}>{ i  + 1}</li>);
                }
            }
            list.push(<li className="page_item page_next" key='next' onClick={(e) => this.nextPageHandler(e)}>{"下一页"}</li>);
        }
        return pageLen > 1 ? (
          <div className="page_wrap">
                <ul className="page_ul">
                  {list}
                </ul>
          </div>
        ): null
    }
}

export default Page;